import { useRouter } from 'expo-router';
import { UserRoundPlus } from 'lucide-react-native';

import { HeaderTextButton } from '@/components/headerItems/HeaderTextButton';
import { NAV_LABELS } from '@/constants/navigation';
import { ROUTES } from '@/constants/routes';
import { useAuthStatus } from '@/hooks/useAuthStatus';
import { useHaptic } from '@/hooks/useHaptic';
import { trackInviteHeaderIconClicked } from '@/util/analyticsEvents';

/**
 * The invite action in a tab header, beside the account avatar.
 *
 * Invite is a growth action with no state to show, so it lives here and not in the tab bar.
 * A bare glyph reads ambiguously, so it carries its name in words, and the spoken label
 * starts with that visible word. It is brand-colored text and icon rather than a second
 * avatar, so it does not read as a person next to the reader's own.
 *
 * Drawn with the shared header text button, so it has the padding of Save and Cancel.
 */
export function InviteHeaderButton() {
  const router = useRouter();

  const haptic = useHaptic();

  const { needsNpiVerification } = useAuthStatus();

  if (needsNpiVerification) {
    return null;
  }

  return (
    <HeaderTextButton
      label={NAV_LABELS.invites.mobileTab}
      icon={UserRoundPlus}
      role="accent"
      accessibilityLabel={NAV_LABELS.invites.mobileTitle}
      accessibilityHint="Opens the invite screen"
      onPress={() => {
        haptic.impactLight();

        trackInviteHeaderIconClicked();

        router.push({ pathname: ROUTES.ACCOUNT_INVITES, params: { source: 'header' } });
      }}
    />
  );
}
